
import { defineComponent, PropType } from 'vue';
import { templateRef } from '@vueuse/core';
import StringsHelper from 'utils/helpers/Strings';

const BuilderQuotes = defineComponent({
  name: 'BuilderQuotes',
  props: {
    title: {
      type: String,
      default: null,
    },
    items: {
      type: Array as PropType<BuilderQuotesItems[]>,
      default: null,
    },
  },
  setup() {
    const elNext:Obj = templateRef('elNext')
    const elPrev:Obj = templateRef('elPrev')

    return {
      elNext, 
      elPrev,
      safeTitle: StringsHelper.safeTitle
    }
  }
});
export default BuilderQuotes
